import Vue from 'vue'
import axios from 'axios'
import router from '../router'


axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.headers.common['Pragma'] = 'no-cache';
axios.defaults.headers.common['Expires'] = '0';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

const httpPublic = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
     'Authorization' : localStorage.getItem('token')
   }
});


http.interceptors.request.use(
  (config) =>  {
      let token = localStorage.getItem('token');
      if(token){
          config.headers['Authorization'] = token;
      }
     return config; 
  }
);


http.interceptors.response.use(null, error => {

let path = '';

switch (error.response && error.response.status) {
  case 401: 
    path = '/'; // Token inválido/expirado -> Volta pro Login
    break;
  case 403: 
    path = '/error'; // Sem permissão -> Tela de Acesso Negado
    break;
  case 500: 
    path = '/error'; // Erro interno
    break;
}

if(path !== '' && router.history.current.path != path){
  router.push(path);
}
return Promise.reject(error);
});

Vue.use({
    install(Vue){
        Vue.prototype.$http = http
        Vue.prototype.$httpPublic = httpPublic
    }
})